<template>
  <div class="deposit">
    <h5>证件押金</h5>
    <div class="setDeposit">
      <span>押金金额: </span>
      <template v-if="isDeposit">
        <el-input v-model="depositValue"
                  placeholder="请输入金额"
                  size="small"></el-input>
        <el-button type="primary"
                   size="small"
                   @click="saveSet">保存</el-button>
      </template>
      <template v-else>
        <span>{{deposit || 0}}</span>
        <el-button type="primary"
                   size="small"
                   @click="changeDeposit">修改</el-button>
      </template>
    </div>
  </div>
</template>

<script>

export default {
  data () {
    return {
      depositValue: '',
      isDeposit: false,
      deposit: null
    }
  },
  computed: {
  },
  components: {
  },
  created () {
    this.init()
  },
  mounted () {
  },
  methods: {
    init () {
      this.getDeposit()
    },
    /**
     * 查看押金
     */
    getDeposit () {
      this.$api.shopapi.getDeposit(2)
        .then(({ code, data, msg }) => {
          if (code === 200) {
            this.deposit = data
          } else {
            this.$message.error(msg);
          }
        })
    },
    /**
     * 修改押金
     */
    changeDeposit () {
      this.isDeposit = true
    },
    /**
     * 保存押金设置
     */
    saveSet () {
      const obj = {
        money: +this.depositValue,
        type: 2
      }
      this.$api.shopapi.setDeposit(obj)
        .then(({ code, data, msg }) => {
          if (code === 200) {
            this.isDeposit = false
            this.getDeposit()
          } else {
            this.$message.error(msg);
          }
        })
    }
  },
  watch: {
  }
}
</script>
<style lang="scss" scoped>
.deposit {
  width: 100%;
  padding: 30px;
  background-color: #fff;
  .setDeposit {
    margin: 50px 0 0 50px;
  }
  .el-button {
    margin-left: 40px;
  }
  .el-input {
    width: 350px;
  }
}
</style>
